<template>
  <div class="flex justify-start mb-3 relative">
    <div
      v-if="planBenefit.abTest && !isProPlan"
      class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
      @click="handleCheckNeedUpgradeShowAccountTab()"
    ></div>
    <aha-checkbox
      v-model="presentation.isAccountTabVisible"
      class="group flex"
      :class="{'remove-css-disable': planBenefit.abTest}"
      :disabled="!isProPlan && isBeforeCurrentPeriodStart && !planBenefit.abTest"
      @change="toggleIsAccountTabVisible()"
    >
      <span>
        {{ $i18nPresenter.t("Show the Account tab on audience's device") }}
        <span
          v-if="isProPlan && !planBenefit.abTest"
          v-tooltip="{
            content: showAccountTabTooltip,
            html: true,
          }"
          class="ml-1 text-secondary-40 cursor-pointer opacity-0 group-hover:opacity-100"
        >
          <i class="fas fa-question-circle" />
        </span>
        <IconNeedUpgradePlan
          v-if="planBenefit.abTest"
          ref="iconNeedUpgradePlanComponentShowAccountTab"
          :noPermission="!isProPlan"
          :defaultTooltip="{
            content: showAccountTabTooltip,
            html: true,
          }"
          left="-215px"
          upgradePlan="pro"
          featureName="Show/Hide Audience App Account Tab"
        />
      </span>
    </aha-checkbox>

    <div
      v-if="!isProPlan && isBeforeCurrentPeriodStart && !planBenefit.abTest"
      class="relative inline-block ml-2"
    >
      <img src="@/assets/images/pro.svg" class="cursor-pointer" @click="openUpgradeToggleAccountTab()" />
      <PlanUpgradeModal
        :plan-for-feature="'Pro'"
        :name-feature="'Show/Hide Audience App Account Tab'"
        :isShowTooltip="ctaUpgradeHideAccountTab"
        left="-215px"
        @outsideEvent="clickOutsideHideAccountTab"
      >
        <template #tooltipcontent>
          <p v-html="showAccountTabTooltip"></p>
        </template>
      </PlanUpgradeModal>
      <div v-if="ctaUpgradeHideAccountTab" class="upgrade-arrow upgrade-arrow_slide"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Util from '@/util'
import Socket from '@/socket'

import eventCategories from '@/constant/eventCategories'

import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgrade.vue'
import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'

export default {
  components: {
    IconNeedUpgradePlan,
    PlanUpgradeModal,
  },
  props: {
    isProPlan: {
      type: Boolean,
      default: false,
    },
    isBeforeCurrentPeriodStart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ctaUpgradeHideAccountTab: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    showAccountTabTooltip() {
      return `
        ${this.$i18nPresenter.t('If this option is unselected:')}
        <ul class="list-disc list-inside pl-2">
          <li>${this.$i18nPresenter.t('The Account tab will be hidden.')}</li>
          <li>${this.$i18nPresenter.t('No login/signup links will be shown.')}</li>
        </ul>
      `
    },
  },
  methods: {
    toggleIsAccountTabVisible() {
      const payload = {
        isAccountTabVisible: this.presentation.isAccountTabVisible,
        socketId: Socket.getSocketId(),
      }

      this.$store.dispatch('updatePresentation', payload)
      this.$emit('updatePresentation', payload)
      Util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'click_checkbox_audience_account_tab_visibility',
        payload.isAccountTabVisible ? 'enable' : 'disable',
        null,
        {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
        },
      )
    },
    openUpgradeToggleAccountTab() {
      if (this.isProPlan) {
        return
      }

      this.ctaUpgradeHideAccountTab = true
    },
    clickOutsideHideAccountTab() {
      this.ctaUpgradeHideAccountTab = false
    },
    handleCheckNeedUpgradeShowAccountTab() {
      if (this.planBenefit.abTest && !this.isProPlan) {
        this.$refs.iconNeedUpgradePlanComponentShowAccountTab.toggleTooltip()
      }
    },
  },
}
</script>
